import { render, staticRenderFns } from "./CompanyForm.vue?vue&type=template&id=27c0415d&scoped=true"
import script from "./CompanyForm.vue?vue&type=script&lang=js"
export * from "./CompanyForm.vue?vue&type=script&lang=js"
import style0 from "./CompanyForm.vue?vue&type=style&index=0&id=27c0415d&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c0415d",
  null
  
)

export default component.exports